import React from "react";
import { useUserInfo } from "../../utils/security";
import { Box, FormControlLabel, Checkbox, FormHelperText } from "@mui/material";
import SliderWithButtons from "../../components/SliderWithButtons";
import { useSettingsForm } from "../settings";

export const TimesheetSettingsCard = () => {
    const { userInfo } = useUserInfo();
    const {
        values,
        handleChange,
        progress: disabled,
    } = useSettingsForm({
        settingsKey: "timesheetsSettings",
    });

    return (
        <>
            {!!userInfo.projectsSupport && (
                <Box mb={4}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={!!values.projectRequired}
                                onChange={handleChange}
                                name="projectRequired"
                            />
                        }
                        label="Pole projekt je povinné"
                        disabled={disabled}
                    />
                    <FormHelperText>
                        Nově vytvořená nebo upravená položka výkazu bude muset mít přiřazený projekt
                    </FormHelperText>
                </Box>
            )}
            {!!userInfo.employeesSupport && (
                <Box mb={4}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={!!values.employeeRequired}
                                onChange={handleChange}
                                name="employeeRequired"
                            />
                        }
                        label="Pole zaměstnanec je povinné"
                        disabled={disabled}
                    />
                    <FormHelperText disabled={disabled}>
                        Nově vytvořená nebo upravená položka výkazu bude muset být přiřazena
                        zaměstnanci
                    </FormHelperText>
                </Box>
            )}
            <Box mb={4}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!values.descriptionRequired}
                            onChange={handleChange}
                            name="descriptionRequired"
                        />
                    }
                    label="Pole popis je povinné"
                    disabled={disabled}
                />
                <FormHelperText disabled={disabled}>
                    Nově vytvořená nebo upravená položka výkazu bude muset mít vyplněný popis
                </FormHelperText>
            </Box>
            <Box mb={4}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!values.roundTo15}
                            onChange={handleChange}
                            name="roundTo15"
                        />
                    }
                    label="Zaokrouhlovat čas na 15 minut"
                    disabled={disabled}
                />
                <FormHelperText disabled={disabled}>
                    Při zadávání času od/do nebo doby trvání položky výkazu bude čas zaokrouhlen na
                    násobky patnácti minut
                </FormHelperText>
            </Box>
            <Box mb={4}>
                <SliderWithButtons
                    title="Maximální doba"
                    minValue={1}
                    maxValue={24}
                    disabled={disabled}
                    value={values.maxHours}
                    onChange={handleChange}
                    name="maxHours"
                    unit="h"
                />
                <FormHelperText sx={{ mt: 2 }} disabled={disabled}>
                    Pokud bude potřeba vykázat více než {values.maxHours} hodin, bude potřeba
                    vytvořit více položek výkazu
                </FormHelperText>
            </Box>
            {/*<pre>{JSON.stringify(userInfo.timesheetsSettings, null, 4)}</pre>*/}
        </>
    );
};
